import sectionBannerBasicCss from '../css-snippets/section-banner-basic';

const html = ` 
<style>${sectionBannerBasicCss}</style>
<div
  id="banner-basic-wrapper-unique-id"
  data-id="unique-id"
  class="banner-basic-wrapper"
  data-attribute="banner-basic-wrapper"
  data-background-color="#ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
  data-card-1-background-color="#01ae74"
  data-card-1-text-color="#ffffff"
  data-card-3-background-color="#efefef"
  data-card-3-text-color="#6d6d6d"
  data-card-4-background-color="#464646"
  data-button-background-color="#464646"
  data-button-text-color="#ffffff"
  data-button-radius="5"
  style="
    --background-color: #ffffff;
    --card-1-background-color: #01ae74;
    --card-1-text-color: #ffffff;
    --card-3-background-color: #efefef;
    --card-3-text-color: #6d6d6d;
    --card-4-background-color: #464646;
    --button-background-color: #464646;
    --button-text-color: #ffffff;
    --button-radius: 5px;
  "
>
  <div data-attribute="banner-basic-container" class="banner-basic-container">
    <div class="banner-basic-cards-top" data-attribute="banner-basic-cards-top">
      <div
        class="banner-basic-card-1"
        data-attribute="banner-basic-card-1"
      >
        <div
          class="banner-basic-card-1-image"
          data-attribute="banner-basic-card-1-image"
        >
          <img
            data-attribute="banner-basic-card-1-image-inner"
            src="https://cdn.skyfastimg.com/images/2026/04/10/image-69d86c64f2ff258b7a0916d0.png?w=500&h=50&q=80"
            alt=""
          />
        </div>
        <div
          class="banner-basic-card-1-text"
          data-attribute="banner-basic-card-1-text"
        >
          At the heart of it all, we lead with purpose.
        </div>
        <a
          href="#"
          class="banner-basic-card-1-button"
          data-attribute="banner-basic-card-1-button"
        >
          LEARN MORE
        </a>
      </div>
      <div
        class="banner-basic-card-2-image-wrapper"
        data-attribute="banner-basic-card-2-image-wrapper"
      >
        <div
          class="banner-basic-card-2-image"
          data-attribute="banner-basic-card-2-image"
        >
          <img
            data-attribute="banner-basic-card-2-image-inner"
            src="https://cdn.skyfastimg.com/images/2026/04/11/image-69da0ecc8f368b0a01f0f496.png?w=50&h=50&q=80"
            alt="img"
          />
        </div>
      </div>
    </div>

    <div class="banner-basic-cards-bottom" data-attribute="banner-basic-cards-bottom">
      <div
        class="banner-basic-card-3"
        data-attribute="banner-basic-card-3"
      >
        <div
          class="banner-basic-card-3-image"
          data-attribute="banner-basic-card-3-image"
        >
          <img
            data-attribute="banner-basic-card-3-image-inner"
            src="https://cdn.skyfastimg.com/images/2026/04/11/image-69da0ede8fffdfca069624a6.png?w=50&h=50&q=80"
            alt=""
          />
        </div>
        <div
          class="banner-basic-card-3-text"
          data-attribute="banner-basic-card-3-text"
        >
          Stripe Climate member.
        </div>
      </div>

      <div
        class="banner-basic-card-4-image-wrapper"
        data-attribute="banner-basic-card-4-image-wrapper"
      >
        <div
          class="banner-basic-card-4-image"
          data-attribute="banner-basic-card-4-image"
        >
          <img
            data-attribute="banner-basic-card-4-image-inner"
            src="https://cdn.skyfastimg.com/images/2026/04/11/image-69da0ee1594d1dbd921fd165.png?w=50&h=50&q=80"
            alt="img"
          />
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
